export const PRODUCT_CATEGORY = 1;

export const CATEGORY_ICON_BY_ID = {
  [PRODUCT_CATEGORY]: 'boxes',
};
